
import ExternalVideo from "./ExternalVideo.vue";
import InternalVideo from "./InternalVideo.vue";

export default {
  name: "VideoBannerV2",

  components: { ExternalVideo, InternalVideo },

  props: { slice: { type: Object, required: true } },
};
